import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { EllipsisSlicePipe } from './ellipsis-slice.pipe';
import { ContainsSubstrOf } from './contains-substr-of.pipe';
import { CurrencyPipe } from './currency.pipe';
import { FilterCartItemsByDayPipe } from './filter-cart-items-by-day.pipe';
import { FilterOrderItemsByDayPipe } from './filter-order-items-by-day.pipe';
import { DeliveryTimePipe } from './delivery-time.pipe';
import { ProductImagePipe } from './product-image.pipe';
import { WeekIndexByWeekNumberPipe } from './week-index-by-week-number.pipe';
import { WeekNumberByWeekIndexPipe } from './week-number-by-week-index.pipe';
import { GetOrderItemStatusPipe } from './get-order-item-status.pipe';
import { GetOrderStatusPipe } from './get-order-status.pipe';
import { PhonePipe } from './phone.pipe';
import { GetDeliveryForDateStatusPipe } from './get-delivery-for-date-status.pipe';
import { GetRelevantProductPricePipe } from './get-relevant-product-price.pipe';
import { GetInStoreCartItemQuantityPipe } from './get-in-store-cart-item-quantity.pipe';
import { GetPrimaryCurrencyPricePipe } from './get-primary-currency-price.pipe';
import { SplitLinesPipe } from './split-lines.pipe';

const declarationsAndExports = [
  EllipsisSlicePipe,
  ContainsSubstrOf,
  CurrencyPipe,
  FilterCartItemsByDayPipe,
  FilterOrderItemsByDayPipe,
  DeliveryTimePipe,
  ProductImagePipe,
  WeekIndexByWeekNumberPipe,
  WeekNumberByWeekIndexPipe,
  GetOrderItemStatusPipe,
  GetOrderStatusPipe,
  PhonePipe,
  GetDeliveryForDateStatusPipe,
  GetRelevantProductPricePipe,
  GetInStoreCartItemQuantityPipe,
  GetPrimaryCurrencyPricePipe,
  SplitLinesPipe,
];

@NgModule({
  declarations: [...declarationsAndExports],
  imports: [CommonModule, TranslateModule],
  exports: [...declarationsAndExports],
})
export class PipesModule {}
